import React from 'react';
import PropTypes from 'prop-types';
import { Router as BrowserRouter, Switch } from 'react-router-dom';
import history from 'utils/history';
import RouteWithSubRoutes from './routeswithSubRoutes';
import routesConfig from './routesConfig';
import { Loading } from 'components';
import { useSelector } from 'react-redux';
import getAllowedRoutes from 'utils/getAllowedRoutes';
import MigrationNotice from 'pages/migrated/migratedNotice';

const Router = ({ isAuthenticate }) => {
  const userInfo = useSelector(state => state.login);
  const userRole = userInfo.isSuperAdmin ? 'admin' : 'client';
  const allowedRoutes = getAllowedRoutes(routesConfig, userRole);

  const isAppMigrated = true; // Set this to true to show the migration notice

  if (isAppMigrated) {
    return <MigrationNotice />;
  }

  return (
    <React.Suspense fallback={<Loading fullScreen={true} />}>
      <BrowserRouter history={history}>
        <Switch>
          {allowedRoutes.map(route => (
            <RouteWithSubRoutes key={route.path} {...route} isAuthenticate={isAuthenticate} />
          ))}
        </Switch>
      </BrowserRouter>
    </React.Suspense>
  );
};

Router.propTypes = {
  isAuthenticate: PropTypes.bool.isRequired,
};

export default Router;
